export default __webpack_public_path__ + "static/media/health_check_3x2_En.5f434ff5.webp";